if (CONTROLLER === 'legacy_surveys' && ACTION === 'show') {
  var $document = $(document);

  $document.on('submit', 'li.question form', function (e) {
    e.preventDefault();
    var $form = $(this);
    var opts = { type: $form.attr('method'), data: $form.serialize() };
    // On error alert the users
    opts.error = function (e) {
      alert('Could not save - please check your connection.');
    };
    opts.success = function (data, status, xhr) {
      //do nothing
    };
    $.ajax($form.attr('action'), opts);
  });
}

if (CONTROLLER === 'survey_summary_imports' && ACTION === 'index') {
  var $document = $(document);

  $document.on(
    'change',
    '#benchmark_report_id, #historical_survey_id',
    function (e) {
      const select = $(this);

      const selectedOption = select.find('option:selected');
      const selectedName = selectedOption.val() ? selectedOption.text() : null;

      const nameInput = select.closest('form').find('[name="summary_name"]');
      const isEmptyName = nameInput.val().trim() === '';

      if (isEmptyName && selectedName) {
        nameInput.val(selectedName);
      }
    }
  );
}
